import React from 'react';
import LanguageIcon from '@components/LanguageIcon';
// flags are taken from flaticons
import {
  spain,
  unitedKingdom,
  germany,
  czech,
  japan,
  slovakia,
  italy,
  france,
  poland,
  portugal,
  brazil,
  hongKong,
} from '../assets/icons';
import { faGlobe, faFlagAlt, faHospital } from '@fortawesome/pro-regular-svg-icons';
import i18n from '../i18n';
import { languageCatalog, languageCodes, resolveLanguageCode } from './languageCatalog';

export { resolveLanguage } from './resolveLanguage';
export {
  languageCodes,
  lookupTranslatedName,
  matchesLanguageCode,
  resolveLanguageCode,
} from './languageCatalog';

const languageIcons = {
  en: unitedKingdom,
  es: spain,
  de: germany,
  cs: czech,
  ja: japan,
  sk: slovakia,
  it: italy,
  fr: france,
  pl: poland,
  pt: portugal,
  'pt-br': brazil,
  'zh-hk': hongKong,
};

const supportedLanguages = languageCodes.reduce((languages, code) => {
  languages[code] = {
    ...languageCatalog[code],
    icon: languageIcons[code],
  };
  return languages;
}, {});

export const selectLanguageIcon = (code = '') => {
  switch (resolveLanguageCode(code)) {
    case 'de':
      return germany;
    case 'es':
      return spain;
    case 'en':
      return unitedKingdom;
    case 'cs':
      return czech;
    case 'it':
      return italy;
    case 'fr':
      return france;
    case 'pl':
      return poland;
    case 'pt':
      return portugal;
    case 'pt-br':
      return brazil;
    case 'zh-hk':
      return hongKong;
    default:
      return unitedKingdom;
  }
};

export const selectLanguageLegend = code => {
  switch (resolveLanguageCode(code)) {
    case 'de':
      return i18n.t('common:languages.german');
    case 'es':
      return i18n.t('common:languages.spanish');
    case 'en':
      return i18n.t('common:languages.english');
    case 'cs':
      return i18n.t('common:languages.czech');
    case 'it':
      return i18n.t('common:languages.italian');
    case 'fr':
      return i18n.t('common:languages.french');
    case 'pl':
      return i18n.t('common:languages.polish');
    case 'pt':
      return i18n.t('common:languages.portuguese');
    case 'pt-br':
      return i18n.t('common:languages.portugueseBrazil');
    case 'zh-hk':
      return i18n.t('common:languages.chinese');
    default:
      return i18n.t('common:languages.english');
  }
};

export const selectSourceLegend = source => {
  switch (source) {
    case 'global':
    case 'GLOBAL':
      return i18n.t('common:sources.global');
    case 'country':
    case 'COUNTRY':
      return i18n.t('common:sources.country');
    case 'hospital':
    case 'HOSPITAL':
      return i18n.t('common:sources.hospital');
    default:
      return i18n.t('common:sources.global');
  }
};

export const selectSourceIcon = source => {
  switch (source) {
    case 'global':
    case 'GLOBAL':
      return faGlobe;
    case 'country':
    case 'COUNTRY':
      return faFlagAlt;
    case 'hospital':
    case 'HOSPITAL':
      return faHospital;
    default:
      return faGlobe;
  }
};

export const createLanguageFilters = t =>
  Object.values(supportedLanguages).map(language => ({
    text: (
      <span className="table-language-filters-label">
        <LanguageIcon language={language.key} /> <span>{t(language.name)}</span>
      </span>
    ),
    value: language.key,
  }));

export default supportedLanguages;
